export function hasMonitoringAccess(user?: { access_ucc?: boolean | null; access_monitoring?: boolean | null } | null): boolean {
	return user?.access_ucc === true && user.access_monitoring === true;
}
